import React from "react";
import type {VoidFunctionComponent} from "react";
import s from "./SongsPageNavigationItem.module.scss";
import {useSongsPageNavigationItemLogic} from "./SongsPageNavigationItem.logic";

export interface ISongsPageNavigationItemProps {
  resultsPageLink: "home" | "browse" | "library";
  title: string;
}

export const SongsPageNavigationItem: VoidFunctionComponent<ISongsPageNavigationItemProps> = ({resultsPageLink, title}) => {
  const {isActive} = useSongsPageNavigationItemLogic(resultsPageLink);
  const useClasses = [
    s.navItem,
  ];
  if (isActive){
    useClasses.push(s.active);
  }
  return (
    <div className={useClasses.join(` `)}>
      <a className={s.navLink} href={`#/songs/${resultsPageLink}`} > {title} </a>
    </div>
  );
}

